import { REWARDS_REWARD_TYPES } from "@modules/nudges/types";
import { assign, literal, number, object, string } from "superstruct";

export const RewardsGiftCardRewardSchema = object({
    type: literal(REWARDS_REWARD_TYPES.giftCard),
    initialValue: number(),
});

export const RewardsGiftCardBalanceRewardSchema = assign(
    RewardsGiftCardRewardSchema,
    object({
        code: string(),
        balance: number(),
    })
);
